import { render, staticRenderFns } from "./company-oems.vue?vue&type=template&id=a29ffbd2&scoped=true&"
import script from "./company-oems.vue?vue&type=script&lang=js&"
export * from "./company-oems.vue?vue&type=script&lang=js&"
import style0 from "./company-oems.vue?vue&type=style&index=0&id=a29ffbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29ffbd2",
  null
  
)

export default component.exports